
import React from 'react';
import Paper from '@material-ui/core/Paper';
import MenuList from '@material-ui/core/MenuList';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';

import { YellowButton } from './Button';


export const ButtonMenu = (props) => {
  const { label, size, color, ButtonComponent, disabled, component, startIcon } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const childrenIsFunction = typeof props.children === 'function';

  return (
    <React.Fragment>
      <ButtonComponent
        size={size}
        color={color}
        disabled={disabled}
        startIcon={startIcon}
        onClick={handlePopoverOpen}
      >
        {label}
      </ButtonComponent>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Paper>
          <MenuList component={component}>
            {childrenIsFunction ? props.children(handlePopoverClose) : props.children}
          </MenuList>
        </Paper>
      </Popover>
    </React.Fragment>
  );
};

ButtonMenu.defaultProps = {
  ButtonComponent: Button
};


export const YellowButtonMenu = (props) => {
  return (
    <ButtonMenu {...props} ButtonComponent={YellowButton} />
  );
};
